export const samplerAttackMilliseconds = (normalized) => (
  5000 * (Math.max(0, Math.min(1, Number(normalized) || 0)) ** 2.5)
);

export const samplerReleaseMilliseconds = (normalized) => (
  10 + 9990 * (Math.max(0, Math.min(1, Number(normalized) || 0)) ** 2.2)
);

